export const lawyerNav = [
  {
    id: 'lawyer-profile',
    textId: 'app.pages.lawyer.nav.profile',
    exist: true,
  },
  {
    id: 'lawyer-commentaries',
    textId: 'app.pages.lawyer.nav.commentaries',
    exist: false,
  },
  {
    id: 'lawyer-last-decisions',
    textId: 'app.pages.lawyer.nav.lastDecisions',
    exist: false,
  },
  {
    id: 'lawyer-expertises',
    textId: 'app.pages.lawyer.nav.expertises',
    exist: false,
  },
  {
    id: 'lawyer-clients',
    textId: 'app.pages.lawyer.nav.clients',
    exist: false,
  },
];
